import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import OKomBreadcrumb from '../Components/OsloKommuneUI/OKomBreadcrumb';

interface ReportTile {
  label: string;
  icon: string;
  href?: string;
  disabled: boolean;
}

const renderTile = (tile: ReportTile, key: number) => {
  const card = (
    <div className="ods-status-card frontpage-card">
      <div className="ods-status-card__content">
        <span className={`ods-icon ods-icon--size-kilo ods-icon--size-echo-breakpoint-medium ${tile.icon}`} aria-hidden="true"></span>
        <span className="ods-text--size-kilo ods-text--size-echo-breakpoint-medium">{tile.label}</span>
      </div>
    </div>
  );
  return (
    <div key={key} className={tile.disabled ? "ods-grid__column--6 ods-grid__column--4-breakpoint-medium ods-color-text-grayscale-10" : "ods-grid__column--6 ods-grid__column--4-breakpoint-medium"}>
      {tile.disabled || !tile.href ? card : (
        <a href={tile.href} className="o-kom-link" style={{ display: 'block' }}>{card}</a>
      )}
    </div>
  );
};

const RapporterView: React.FC<RouteComponentProps> = () => {
  const tiles: ReportTile[] = [
    { label: 'Eksamensregistrering', icon: 'ods-icon--document',           href: '/reports/examregistration',       disabled: false },
    { label: 'Friidrettsregistrering', icon: 'ods-icon--document',         href: '/reports/athleticsregistration',  disabled: false },
    { label: 'Brukere',              icon: 'ods-icon--user',                                                        disabled: true  },
    { label: 'Inntekter',            icon: 'ods-icon--coin-stacks',                                                 disabled: true  },
    { label: 'Romutleie',            icon: 'ods-icon--calendar',                                                    disabled: true  },
    { label: 'Fravær',               icon: 'ods-icon--success-square',                                              disabled: true  },
    { label: 'Aktivitetslogg',       icon: 'ods-icon--message',                                                     disabled: true  },
  ];

  const sorted = [...tiles].sort((a, b) => Number(a.disabled) - Number(b.disabled));

  return (
    <>
      <OKomBreadcrumb path='Rapporter'></OKomBreadcrumb>
      <div className="ods-grid ods-grid--gap ods-grid--center ods-margin-top-11 ods-text--align-center">
        {sorted.map((tile, i) => renderTile(tile, i))}
      </div>
    </>
  );
};

export default withRouter(RapporterView);
